export default "__VITE_ASSET__C$RZJhsD__"